

























import { Component, Vue, Provide } from "vue-property-decorator";
import { authService } from './services/AuthService';
import { toastService } from './services/ToastService';
import { logService } from '@/services/LogService';

@Component({
})
export default class Login extends Vue {

    usuario: string = "";
    password: string = "";

    drawer: any = null;
    created(){
        logService.Info("Inicio","Login.vue - created()");
    }

    login(){
      logService.Info("Inicio","Login.vue - login()");
      authService.login(this.usuario, this.password)
      .then((res) => {
        if(res){
          window.location.href = "/";
        }else{
          logService.Info("Usuario y/o contraseña incorrectos.","Login.vue - login()");
          toastService.error("Usuario y/o contraseña incorrectos.");
        }        
      });
    }
}
